import commonUtil from "../../../../../util/common-utils";

export interface CategoryEditorOptionRow {
    th: string;
    en: string;
    ja: string;
}

export class CategoryEditorRender {
    /**
     * @param {HTMLElement} container
     * @param {Array<{th:string,en:string,ja:string}>} rows
     */
    public static renderQuestionOptionRows(container: HTMLElement, rows: CategoryEditorOptionRow[]): void {
        const safeRows = Array.isArray(rows) && rows.length > 0 ? rows : [{ th: "", en: "", ja: "" }];
        const rowHtml = safeRows
            .map((row, index) => {
                const num = index + 1;
                return `
                    <div class="category-review-editor__option-row" data-row-index="${num}">
                        <div class="category-review-editor__option-no">${num}</div>
                        <input type="text" class="form-control form-control-sm" data-action="question-option-row-th" value="${commonUtil.escapeHtmlAttribute(String(row.th || ""))}" placeholder="TH" />
                        <input type="text" class="form-control form-control-sm" data-action="question-option-row-en" value="${commonUtil.escapeHtmlAttribute(String(row.en || ""))}" placeholder="EN" />
                        <input type="text" class="form-control form-control-sm" data-action="question-option-row-ja" value="${commonUtil.escapeHtmlAttribute(String(row.ja || ""))}" placeholder="JA" />
                        <button type="button" class="btn-circle delete category-review-editor__icon-btn category-review-editor__icon-btn--delete category-review-editor__option-remove" data-action="question-option-remove-row" title="Remove" aria-label="Remove"></button>
                    </div>
                `;
            })
            .join("");

        container.innerHTML = `
            <div class="category-review-editor__option-head"><div>#</div><div>TH</div><div>EN</div><div>JA</div><div></div></div>
            <div class="category-review-editor__option-body">${rowHtml}</div>
        `;
    }

    /**
     * @param {HTMLElement} container
     */
    public static clearQuestionOptionRows(container: HTMLElement): void {
        container.innerHTML = "";
    }
}
